import React, { useEffect } from "react";
import PageHeader from "../components/PageHeader";

const Clienti: React.FC = () => {
  useEffect(() => {
    document.title = "CO.ME.ST. S.R.L - Il Nostro Approccio al Cliente";
  }, []);

  const customerJourney = [
    {
      icon: "💡",
      title: "Ascolto e Progettazione Condivisa",
      description:
        "Tutto inizia con l'ascolto. Analizziamo le vostre esigenze, studiamo le specifiche e collaboriamo a stretto contatto per definire la migliore strategia progettuale. La vostra visione è la nostra guida.",
    },
    {
      icon: "🔬",
      title: "Sviluppo e Prototipazione",
      description:
        "Trasformiamo le idee in prototipi tangibili. In questa fase, la precisione è fondamentale. Utilizziamo tecnologie avanzate per creare modelli fedeli, permettendovi di validare il design prima della produzione di massa.",
    },
    {
      icon: "🏭",
      title: "Produzione e Controllo Qualità",
      description:
        "La nostra esperienza nello stampaggio e assemblaggio entra in gioco. Ogni pezzo è prodotto secondo i più alti standard, con un controllo qualità meticoloso che garantisce la conformità e l'eccellenza che ci contraddistingue.",
    },
    {
      icon: "🤝",
      title: "Consegna e Supporto Continuo",
      description:
        "Il nostro impegno non si conclude con la consegna. Offriamo un supporto post-vendita affidabile e rimaniamo vostri partner per ogni esigenza futura, garantendo una collaborazione proficua e a lungo termine.",
    },
  ];

  return (
    <div className="bg-white">
      <PageHeader title="Rapporto con i Clienti" breadcrumb="Clienti" />

      <div className="container px-4 py-16 mx-auto sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl">
          <header className="mb-16 text-center">
            <h1 className="text-4xl font-extrabold tracking-tight text-gray-900 sm:text-5xl">
              Un Partner, Non Solo un Fornitore
            </h1>
            <p className="mx-auto mt-6 max-w-2xl text-xl text-gray-600">
              La nostra filosofia si basa sulla costruzione di relazioni
              durature, fondate sulla fiducia, la trasparenza e la
              collaborazione in ogni fase del progetto.
            </p>
          </header>

            <div className="relative">
              {/* Desktop Timeline */}
              <div className="hidden absolute left-1/2 w-1 h-full bg-indigo-200 transform -translate-x-1/2 md:block"></div>
              {/* Mobile Timeline */}
              <div className="absolute left-10 w-1 h-full bg-indigo-200 transform -translate-x-1/2 md:hidden"></div>

              {customerJourney.map((item, index) => (
                <div key={index}>
                  {/* Desktop View */}
                  <div className="hidden relative items-center mb-12 md:flex">
                    <div className="flex-1">
                      <div
                        className={`text-right pr-8 ${
                          index % 2 !== 0 ? "invisible" : ""
                        }`}
                      >
                        <h3 className="text-2xl font-bold text-gray-800">
                          {item.title}
                        </h3>
                        <p className="mt-2 text-gray-600">{item.description}</p>
                      </div>
                    </div>
                    <div className="relative z-10">
                      <div className="flex justify-center items-center w-20 h-20 text-4xl text-white bg-indigo-600 rounded-full shadow-lg">
                        {item.icon}
                      </div>
                    </div>
                    <div className="flex-1">
                      <div className={`pl-8 ${index % 2 === 0 ? "invisible" : ""}`}>
                        <h3 className="text-2xl font-bold text-gray-800">
                          {item.title}
                        </h3>
                        <p className="mt-2 text-gray-600">{item.description}</p>
                      </div>
                    </div>
                  </div>
                  
                  {/* Mobile View */}
                  <div className="flex items-start mb-8 md:hidden">
                    <div className="relative z-10 flex-shrink-0">
                      <div className="flex justify-center items-center w-20 h-20 text-4xl text-white bg-indigo-600 rounded-full shadow-lg">
                        {item.icon}
                      </div>
                    </div>
                    <div className="ml-6">
                      <h3 className="text-xl font-bold text-gray-800">{item.title}</h3>
                      <p className="mt-2 text-gray-600">{item.description}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <footer className="mt-16 text-center">
            <h2 className="text-3xl font-bold text-gray-900">
              La Vostra Soddisfazione è il Nostro Miglior Prodotto
            </h2>
            <p className="mx-auto mt-4 max-w-xl text-lg text-gray-600">
              Siamo orgogliosi di costruire non solo componenti di alta qualità,
              ma anche relazioni di successo durature nel tempo.
            </p>
          </footer>
        </div>
      </div>
    </div>
  );
};

export default Clienti; 